import { render, staticRenderFns } from "./ProformaRentalList.vue?vue&type=template&id=6ef3b2c8&scoped=true"
import script from "./ProformaRentalList.vue?vue&type=script&lang=js"
export * from "./ProformaRentalList.vue?vue&type=script&lang=js"
import style0 from "./ProformaRentalList.vue?vue&type=style&index=0&id=6ef3b2c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef3b2c8",
  null
  
)

export default component.exports